module.exports = __webpack_public_path__ + "img/empty.4c4a6f94.jpg";